import * as BaseSentry from "@sentry/react";

import { sentryDsn } from "../../config";

const init = () => {
  BaseSentry.init({
    dsn: sentryDsn,
    enabled: import.meta.env.PROD,
  });
};

export const Sentry = {
  addBreadcrumb: BaseSentry.addBreadcrumb,
  captureException: BaseSentry.captureException,
  init,
  setUser: BaseSentry.setUser,
};
